<div class="layout--column layout--gap-larger">
  @for (l of [].constructor(3); track l) {
    <div class="card">
      <div class="p-4 surface-card">
        <div class="flex mb-3">
          <div>
            <p-skeleton width="10rem" styleClass="mb-4"></p-skeleton>
          </div>
        </div>
        <p-skeleton width="100%" height="200px"></p-skeleton>
      </div>
    </div>
  }
</div>
